import { styled as muiStyled } from '@mui/material';

export const MonthText = muiStyled('span')({
  textTransform: 'capitalize',
});
